import { useMemo, useState, type ReactElement } from 'react';
import classNames from 'classnames';

import { SectionTitle } from '@/components';
import { type HemerotecaSearchValues } from './components/HemerotecaSearchForm/config';
import { HemerotecaHero } from './components/HemerotecaHero';
import { HemerotecaResults } from './components/HemerotecaResults';

const classNameComponent = 'p-hemeroteca';

type HemerotecaProps = {
	readonly className?: string;
};

const TITLE = 'Conferencias de la Academia Matritense del Notariado';

export const Hemeroteca = ({ className }: HemerotecaProps): ReactElement => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const [filters, setFilters] = useState<HemerotecaSearchValues | null>(null);

	const handleSearch = (payload: HemerotecaSearchValues) => {
		setFilters(payload);
	};

	return (
		<div className={wrapperClassName}>
			{/* <SectionTitle title={TITLE} tag="h1" align="center" className="u-mb-16" /> */}
			<div className={`${classNameComponent}__content`}>
				<div className="[ o-grid ]">
					<div className="o-grid__row">
						<div className="o-grid__col-12 o-grid__col-6@desktop">
							<HemerotecaHero onSearch={handleSearch} />
						</div>
						<div className="o-grid__col-12 o-grid__col-6@desktop" style={{ height: '100%' }}>
							<HemerotecaResults filters={filters} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
